import PodcastTopicList from './PodcastTopicList';
import PodcastTopicEdit from './PodcastTopicEdit';
import PodcastTopicCreate from "./PodcastTopicCreate";

export default {
    list: PodcastTopicList,
    edit: PodcastTopicEdit,
    create: PodcastTopicCreate,
};
